import type { RouteObject } from 'react-router';
import { parentNav } from '@/lib/nav/parent';
import { collectRoutes } from '../routes';

const modules = import.meta.glob<{ routes: RouteObject[] }>('./*/routes.tsx', { eager: true });

export const parentRoutes = collectRoutes(modules, parentNav, '/parent');
